import React from 'react'
import { usePanelResize } from './usePanelResize'
import {
  ResizableDetailPanelProps,
  DetailPanelHeaderProps,
  DetailPanelContentProps,
  DetailPanelFooterProps,
} from './ResizableDetailPanel.types'
import {
  StyledDetailPanel,
  StyledDetailPanelHeader,
  StyledDetailPanelContent,
  StyledDetailPanelFooter,
  ResizeHandle,
} from './ResizableDetailPanel.styles'

export const ResizableDetailPanel: React.FC<ResizableDetailPanelProps> = ({
  isOpen,
  onClose,
  children,
  storageKey,
  defaultWidth = '800px',
  minWidth = 400,
  maxWidthPercentage = 0.8,
  contained = false,
}) => {
  const { panelWidth, isResizing, handleResizeStart } = usePanelResize({
    storageKey,
    defaultWidth,
    minWidth,
    maxWidthPercentage,
  })

  return (
    <StyledDetailPanel
      $isOpen={isOpen}
      $width={panelWidth}
      $isResizing={isResizing}
      $contained={contained}
      data-resizable-panel
    >
      <ResizeHandle onMouseDown={handleResizeStart} />
      {children}
    </StyledDetailPanel>
  )
}

export const DetailPanelHeader: React.FC<DetailPanelHeaderProps> = ({
  children,
  onClose,
  className,
}) => {
  return (
    <StyledDetailPanelHeader className={className}>
      {onClose && (
        <button
          onClick={onClose}
          style={{
            width: '32px',
            height: '32px',
            border: 'none',
            background: 'transparent',
            borderRadius: '6px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#6b6b6b',
            transition: 'all 0.2s',
            marginLeft: '-8px',
            marginRight: '16px',
            flexShrink: 0,
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = '#f5f5f5'
            e.currentTarget.style.color = '#1a1a1a'
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = 'transparent'
            e.currentTarget.style.color = '#6b6b6b'
          }}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M18 6 6 18M6 6l12 12" />
          </svg>
        </button>
      )}
      {children}
    </StyledDetailPanelHeader>
  )
}

export const DetailPanelContent: React.FC<DetailPanelContentProps> = ({
  children,
  className,
}) => {
  return (
    <StyledDetailPanelContent className={className}>
      {children}
    </StyledDetailPanelContent>
  )
}

export const DetailPanelFooter: React.FC<DetailPanelFooterProps> = ({
  children,
  className,
}) => {
  return (
    <StyledDetailPanelFooter className={className}>
      {children}
    </StyledDetailPanelFooter>
  )
}
